import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import './TreeSelectionList.scss';
import ChevronDownIcon from 'Components/icons/ChevronDownIcon';
import { Collapse } from 'react-collapse';

class TreeSelectionList extends Component {
  constructor(props){
    super(props);
    this.toggleCollapse = this.toggleCollapse.bind(this);  
    this.handleHeaderCheckChange = this.handleHeaderCheckChange.bind(this);
  }

toggleCollapse(item){  
  this.props.toggleCollapse(item);  
}

handleHeaderCheckChange = (item) => (e) =>{  
  item.selected = e.target.checked;
  this.props.handleHeaderCheckbox(item);
}
  render(){     
    const items = this.props.dataList.map((item) => {
    return (
        <li className="tree-selection-list-item" role="menuitem" key={item.key} tabIndex={0}>   
          <div className="item-header">
            <span  className="mr-5" role="button" onClick={() => {this.toggleCollapse(item)}}> <ChevronDownIcon width='10' height='9' transform={item.isExpanded ? 'rotate(0)' : 'rotate(-90)'}/> </span> 
            <Checkbox
              indeterminate = {item.isIndeterminate}
              onChange={this.handleHeaderCheckChange(item)}
              checked={item.selected}
            >         
            </Checkbox>   
            <div  className="group" role="button" onClick={() => {this.toggleCollapse(item)}}>
              {item.key}  
            </div>  
            <div className="subtitle" role="button" onClick={() => {this.toggleCollapse(item)}}>{item.analystsCount} Analysts</div>
          </div>
          <Collapse isOpened={item.isExpanded}>
            <div>
              {item.items.map((child) => {
                const key = `${item.key}_${child.userId}`
                return (
                        <span id="label" key={key} className="vertical-nav-label">
                          <Checkbox onChange={() => { this.props.handleChange(child); }}
                            checked={child.selected}>
                            {child.firstName} {child.lastName}
                           </Checkbox>       
                        </span>
                         )
                })}
            </div>
          </Collapse>   
      </li>
      );
    });
    return (
      <Collapse isOpened={this.props.visible}>
      <div className='tree-selection-list'>
          <ol className="tree-selection-list-items">
            {items}
          </ol>
      </div>
      </Collapse>
    )
  }
 
};

TreeSelectionList.propTypes = {
  dataList: PropTypes.array.isRequired,  
  extraClass: PropTypes.string,
  visible: PropTypes.bool,
  searchTerm: PropTypes.string,
  handleChange: PropTypes.func,
  handleHeaderCheckbox: PropTypes.func,
  toggleCollapse: PropTypes.func
};

TreeSelectionList.defaultProps = {
  extraClass: '',  
  searchTerm: '',
};

export default TreeSelectionList;
